// @flow
import { createAction } from 'redux-actions';
import * as types from '../constants/Api';

/*
----------
General actions
----------
 */
export const apiLoading = createAction(types.API_LOADING);
export const apiLoadingAction = payload => dispatch => dispatch(apiLoading(payload));

export const apiLoaded = createAction(types.API_LOADED);
export const apiLoadedAction = payload => dispatch => dispatch(apiLoaded(payload));

export const servicesLoading = createAction(types.SERVICES_LOADING);
export const servicesLoadingAction = payload => dispatch => dispatch(servicesLoading(payload));

export const servicesLoaded = createAction(types.SERVICES_LOADED);
export const servicesLoadedAction = payload => dispatch => dispatch(servicesLoaded(payload));

/*
----------
Address actions.
----------
 */
export const getAddressAutosuggest = createAction(types.GET_ADDRESS_AUTOSUGGEST);
export const getAddressAutosuggestAction = payload => dispatch =>
  dispatch(getAddressAutosuggest(payload));
